import { useEffect } from 'react';
import logger from 'utils/logger';
import { MESSAGE_SOUND_LOCK_KEY, NIC_RINGTONE_URL } from 'stores/nic/utils/helpers';
var incomingMessageSound = new Audio(NIC_RINGTONE_URL);
incomingMessageSound.loop = true;
incomingMessageSound.volume = 0.8;
var stopMessageSound = function () {
    incomingMessageSound.pause();
    incomingMessageSound.currentTime = 0;
};
/** Drops the message sound lock only when it belongs to this tab. */
var releaseMessageSoundLock = function () {
    var tabId = sessionStorage.getItem('tabId');
    var messageSoundTabId = localStorage.getItem(MESSAGE_SOUND_LOCK_KEY);
    if (tabId && (messageSoundTabId === null || messageSoundTabId === void 0 ? void 0 : messageSoundTabId.startsWith("".concat(tabId, ":")))) {
        localStorage.removeItem(MESSAGE_SOUND_LOCK_KEY);
    }
};
/**
 * Rings until the incoming chat is accepted or rejected, the same way
 * `useIncomingCallRingtone` does for calls — only the WebRTC owner tab rings.
 */
export var useIncomingMessageSound = function (_a) {
    var isIncomingChat = _a.isIncomingChat, isWebRtcOwner = _a.isWebRtcOwner, contactId = _a.contactId, setIsWindowOpen = _a.setIsWindowOpen;
    useEffect(function () {
        var _a;
        if (!isIncomingChat) {
            releaseMessageSoundLock();
            stopMessageSound();
            return;
        }
        setIsWindowOpen(true);
        // Read the owner from localStorage as well, so a tab whose store flag is
        // stale after a takeover cannot ring alongside the real owner.
        var tabId = sessionStorage.getItem('tabId');
        var ownsWebRtc = !!tabId &&
            isWebRtcOwner &&
            tabId === localStorage.getItem('webRtcOwnerTabId');
        if (!ownsWebRtc || !contactId) {
            // Covers losing ownership mid-ring: hand the lock back and go quiet.
            releaseMessageSoundLock();
            stopMessageSound();
            return;
        }
        var _b = ((_a = localStorage.getItem(MESSAGE_SOUND_LOCK_KEY)) === null || _a === void 0 ? void 0 : _a.split(':')) || [], lockTabId = _b[0], lockContactId = _b[1];
        // Another tab is already ringing this same chat. A lock left over from an
        // earlier contact is ignored on purpose - it must not silence this one.
        if (lockContactId === contactId && lockTabId !== tabId)
            return;
        localStorage.setItem(MESSAGE_SOUND_LOCK_KEY, "".concat(tabId, ":").concat(contactId));
        incomingMessageSound.play().catch(function (error) {
            logger.logError('Failed to play incoming message sound', {}, error);
        });
    }, [isIncomingChat, isWebRtcOwner, contactId, setIsWindowOpen]);
};
